<template>
  <div class="history-course-page">
    <div class="history-course-content">
      <div style="padding: 0 20px">
      <div class="user-his-detail">
        <div style="text-align: left; padding-top: 5px; padding-left: 5px; padding-bottom: 5px">
          {{ startDate }} - {{ endDate }}
        </div>
        <div>
          <div>
            <div class="num">{{ integralTotal }}</div>
            <div>总学分</div>
          </div>
          <div>
            <div class="num">{{ integralDh }}</div>
            <div>兑换学分</div>
          </div>
          <div>
            <div class="num">{{ integral }}</div>
            <div>当年学分</div>
          </div>
        </div>
      </div>

      <div class="content-box my-cource">
        <div class="content-box-title">课程列表</div>
        <div class="cource" style="padding-top: 0px">
          <div class="my-cource-filter">
            <div class="year-dropdown">
              <van-dropdown-menu active-color="#d5001c" :overlay="false">
                <van-dropdown-item v-model="studyYear" :options="yearOptions" @change="changeYear" />
              </van-dropdown-menu>
            </div>
            <div class="select-btn" @click="picker = true"><van-icon name="filter-o" />筛选</div>
          </div>
          <div class="cource-list-tool">
            <div @click="changeType(2)" :class="{ active: currentType == 2 }">已学课程</div>
            <div @click="changeType(3)" :class="{ active: currentType == 3 }">兑换课程</div>
          </div>
          <div class="cource-list">
            <div
              class="cource-list-item"
              v-for="(item, i) in dataList"
              :key="i"
              @click="showDetailPop(item)"
            >
              <div class="name">
                <van-image
                  :src="
                    require('../../assets/img/c-type-' + (item.source ? item.source : '1') + '.png')
                  "
                  width="24"
                  height="16"
                />
                <span>{{ item.courseName }}</span>
              </div>
              <div class="price" v-if="item.integral > 0">
                +{{ item.integral.toLocaleString('en-US') }}
              </div>
              <div class="price" v-else>
                {{ item.integral.toLocaleString('en-US') }}
              </div>
              <div>
                <span class="complete"><van-icon name="success" />Completed</span>
              </div>
            </div>
          </div>
          <van-pagination
            class="course-page"
            v-model="pageNum"
            :total-items="total"
            :items-per-page="pageSize"
            mode="simple"
            @change="changePage"
          />
        </div>
      </div>
      </div>
    </div>

    <van-popup v-model="picker" round closeable position="bottom" class="course-filter-popup">
      <div class="course-filter-pop">
        <div class="course-filter-pop__title">课程分类</div>
        <div class="course-filter-pop__tags">
          <div
            v-for="types in typeList"
            :key="types.id"
            class="course-filter-pop__tag"
            :class="{ active: types.id == selectType }"
            @click="selectType = types.id"
          >
            {{ types.title }}
          </div>
        </div>

        <div class="course-filter-pop__title">课程形式</div>
        <div class="course-filter-pop__tags">
          <div
            v-for="course in courseParams"
            :key="course.dictValue"
            class="course-filter-pop__tag"
            :class="{ active: course.dictValue == selectCourse }"
            @click="selectCourse = course.dictValue"
          >
            {{ course.dictLabel }}
          </div>
        </div>
        <div class="course-filter-pop__btns">
          <div @click="reset" class="course-filter-pop__reset">重置</div>
          <div @click="submitPop" class="course-filter-pop__submit">确定</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showDetail" round position="bottom" :style="{ minHeight: '40%' }">
      <div class="detail-pop">
        <div class="detail-pop-title">
          <div>课程详情</div>
          <van-image
            :src="require('../../assets/img/close.png')"
            width="22"
            height="22"
            @click="showDetail = false"
          />
        </div>
        <div class="detail-pop-contnet">
          <h3>{{ detailItem.courseName }}</h3>
          <div
            v-html="detailItem.introduction ? detailItem.introduction : detailItem.courseName"
          ></div>
        </div>
      </div>
    </van-popup>

    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import '@/assets/_variable.scss'
import { getMyCourse, getMapList } from '@/api/common/index.js'
import { getDictType } from '@/api/index.js'
import { getHistory, getUserByPpn } from '@/api/user/index.js'

export default {
  name: 'HistoryCourseList',
  data() {
    return {
      currentType: 2,
      startDate: '',
      endDate: '',
      integral: 0,
      integralTotal: 0,
      integralDh: 0,
      dataList: [],
      pageNum: 1,
      pageSize: 15,
      total: 0,
      picker: false,
      typeList: [],
      selectType: null,
      courseParams: [],
      selectCourse: null,
      studyYear: null,
      yearOptions: [],
      yearStatsMap: {},
      yearValueMap: {},
      showDetail: false,
      detailItem: {},
      ppn: '',
    }
  },
  methods: {
    showDetailPop(obj) {
      this.detailItem = obj
      this.showDetail = true
    },
    getMap() {
      getMapList({}).then((res) => {
        this.typeList = [
          {
            title: '全部',
            id: null,
          },
        ].concat(res.data)
      })
    },
    getCourseType() {
      getDictType('bsd_course_source').then((res) => {
        const list = (res.data || []).filter((item) => {
          const label = String(item.dictLabel || '').toUpperCase()
          const value = String(item.dictValue || '').toUpperCase()
          return label !== 'F2F' && value !== 'F2F' && !label.includes('F2F')
        })
        this.courseParams = [
          {
            dictLabel: '全部',
            dictValue: null,
          },
        ].concat(list)
      })
    },
    getStudyYear() {
      getDictType('study_year').then((res) => {
        const years = []
        ;(res.data || []).forEach((item) => {
          const year = String(item.dictValue).substring(0, 4)
          if (year && !years.includes(year)) {
            years.push(year)
            this.$set(this.yearValueMap, year, item.dictValue)
          }
        })
        this.yearOptions = years.map((year) => ({
          text: year,
          value: year,
        }))
        this.getList()
      })
    },
    getYearStats() {
      getUserByPpn({ ppn: this.ppn }).then((res) => {
        const u = res.data || {}
        if (u.startTime) {
          this.$set(this.yearStatsMap, String(u.startTime).substring(0, 4), {
            startDate: u.startTime,
            endDate: u.endTime,
            integral: Number(u.integral) || 0,
            integralTotal: Number(u.integralTotal) || 0,
            integralDh: Number(u.integralDh) || 0,
          })
        }
      })
      getHistory({ ppn: this.ppn }).then((res) => {
        ;(res.data || []).forEach((item) => {
          this.$set(this.yearStatsMap, String(item.startDate).substring(0, 4), {
            startDate: item.startDate,
            endDate: item.endDate,
            integral: Number(item.integral) || 0,
            integralTotal: Number(item.integralTotal) || 0,
            integralDh: Number(item.integralDh) || 0,
          })
        })
      })
    },
    changeYear() {
      const stats = this.yearStatsMap[String(this.studyYear)]
      if (stats) {
        this.startDate = stats.startDate
        this.endDate = stats.endDate
        this.integral = stats.integral
        this.integralTotal = stats.integralTotal
        this.integralDh = stats.integralDh
      } else {
        this.startDate = ''
        this.endDate = ''
        this.integral = 0
        this.integralTotal = 0
        this.integralDh = 0
      }
      this.pageNum = 1
      this.getList()
    },
    reset() {
      this.selectType = null
      this.selectCourse = null
    },
    submitPop() {
      this.picker = false
      this.pageNum = 1
      this.getList()
    },
    changePage(val) {
      this.pageNum = val
      this.getList()
      this.$nextTick(() => {
        const el = this.$el.querySelector('.history-course-content')
        if (el) el.scrollTop = 0
      })
    },
    changeType(type) {
      this.currentType = type
      this.pageNum = 1
      this.getList()
    },
    getList() {
      getMyCourse(
        {
          learningFlag: '1',
          dhFlag: this.currentType == 3 ? '1' : '0',
          mapId: this.selectType,
          courseSource: this.currentType == 3 ? '4' : this.selectCourse,
          ppn: this.ppn,
          year: this.yearValueMap[this.studyYear] || this.studyYear,
        },
        this.pageNum,
        this.pageSize
      ).then((res) => {
        this.dataList = res.rows || []
        this.total = Number(res.total) || 0
      })
    },
    initQuery() {
      const { startDate, endDate, integral, integralTotal, integralDh } = this.$route.query
      this.startDate = startDate || ''
      this.endDate = endDate || ''
      this.integral = Number(integral) || 0
      this.integralTotal = Number(integralTotal) || 0
      this.integralDh = Number(integralDh) || 0
      this.studyYear = this.startDate ? String(this.startDate).substring(0, 4) : null
    },
  },
  mounted() {
    this.ppn = JSON.parse(localStorage.getItem('user')).ppn
    this.initQuery()
    this.getMap()
    this.getCourseType()
    this.getStudyYear()
    this.getYearStats()
  },
}
</script>

<style lang="scss">
.history-course-page {
  position: relative;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;

  .history-course-content {
    height: 100%;
    padding: 20px 0 120px;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .back-btn {
    z-index: 200;
    bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  }

  .user-his-detail {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 78px;
    border-radius: 6px;
    background: linear-gradient(180deg, #737278 0%, #403f45 100%);
    margin-bottom: 10px;
    & > div {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      text-align: center;
      color: #fff;
    }
    & > div > div {
      padding: 0 30px;
      font-size: 11px;
      text-align: center;
      color: #fff;
      .num {
        font-family: 'Porsche Next Bold';
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  .year-dropdown {
    flex-shrink: 0;
    width: 100px;

    .van-dropdown-menu {
      width: 100px;
    }

    .van-dropdown-menu__bar {
      width: 100px;
      box-shadow: none;
      border: 1px solid rgba(213, 0, 28, 0.5);
      border-radius: 8px;
      height: 28px;
      line-height: 28px;
      background: linear-gradient(180deg, #fff 0%, #fafafa 100%);
      overflow: hidden;
    }

    .van-dropdown-menu__item {
      flex: none;
      width: 100px;
      justify-content: flex-start;
    }

    .van-dropdown-menu__title {
      width: 100px;
      padding: 0 22px 0 10px;
      font-size: 13px;
      font-weight: 500;
      color: #403f45;
      text-align: left;

      &::after {
        display: block;
        right: 10px;
        margin-top: -5px;
        border-color: transparent transparent #d5001c #d5001c;
        opacity: 1;
      }
    }

    .van-dropdown-menu__title--active {
      color: #d5001c;
    }

    .van-dropdown-item--down {
      left: 30px !important;
      right: auto !important;
      width: 100px !important;
    }

    .van-dropdown-item__content {
      width: 100px !important;
      min-width: 100px !important;
      max-width: 100px !important;
    }

    .van-dropdown-item__option {
      padding: 0 8px;
    }

    .van-cell {
      padding: 8px 10px;
      font-size: 13px;
    }
  }

  .my-cource {
    min-height: auto;
    background-size: contain;
    .course-page {
      margin-top: 10px;
      margin-bottom: 10px;
      .van-pagination__item {
        color: #d5001c;
      }
    }
    &-filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .select-btn {
        flex-shrink: 0;
        background: url('../../assets/img/rectangle-select.png') center no-repeat;
        background-size: contain;
        width: 60px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        color: #fff;
        font-size: 13px;
      }
    }
  }
}
</style>

<style lang="scss">
.course-filter-pop {
  padding: 20px 16px 24px;
  max-height: 70vh;
  overflow-y: auto;
  box-sizing: border-box;

  &__title {
    color: #000;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 20px -8px;
  }

  &__tag {
    margin: 0 0 8px 8px;
    padding: 6px 12px;
    font-size: 13px;
    line-height: 18px;
    color: #403f45;
    white-space: nowrap;
    border: 0.5px solid #dad9de;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;

    &.active {
      background-color: rgba(213, 0, 28, 0.2);
      border-color: rgba(213, 0, 28, 0.4);
      color: #d5001c;
    }
  }

  &__btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }

  &__reset,
  &__submit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48%;
    height: 40px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 6px;
    box-sizing: border-box;
  }

  &__reset {
    color: #737278;
    background: url('../../assets/img/reset-btn.png') center no-repeat;
    background-size: 100% 100%;
  }

  &__submit {
    color: #fff;
    background: url('../../assets/img/submit-btn.png') center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
